var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.374.867h12.25c4.667 0 8.459 3.785 8.459 8.443v12.227c0 2.239-.891 4.386-2.478 5.97a8.466 8.466 0 0 1-5.98 2.473H9.374c-4.667 0-8.459-3.785-8.459-8.443V9.31c0-2.24.891-4.387 2.477-5.97A8.466 8.466 0 0 1 9.374.867Zm-.291 2.911A5.255 5.255 0 0 0 5.37 5.313 5.235 5.235 0 0 0 3.833 9.02v12.81a5.242 5.242 0 0 0 5.25 5.24h12.833a5.255 5.255 0 0 0 3.712-1.535 5.235 5.235 0 0 0 1.538-3.706V9.018a5.242 5.242 0 0 0-5.25-5.24H9.083Zm14.073 2.184a1.825 1.825 0 0 1 1.823 1.82A1.818 1.818 0 0 1 23.155 9.6a1.825 1.825 0 0 1-1.823-1.82 1.818 1.818 0 0 1 1.823-1.82Zm-7.657 2.183c1.934 0 3.789.767 5.156 2.132a7.271 7.271 0 0 1 0 10.293 7.298 7.298 0 0 1-10.312 0 7.271 7.271 0 0 1 0-10.293A7.298 7.298 0 0 1 15.5 8.145Zm0 2.912c-1.16 0-2.273.46-3.093 1.278a4.363 4.363 0 0 0 0 6.176 4.379 4.379 0 0 0 6.187 0 4.363 4.363 0 0 0 0-6.175 4.38 4.38 0 0 0-3.094-1.28Z",
    fill: "#4F4F4F"
  })));
};

export default SvgInstagram;